// @mui
import { Button, Card, Collapse, Container, Grid, Typography } from '@mui/material';
import { IConfig, ICreateConfig } from '../../@types/config';
import DashboardLayout from 'layouts/dashboard';
import Markdown from 'components/markdown/Markdown';
import { ConfigKey } from 'utils/constant';
import { GetServerSidePropsContext } from 'next';
import axiosInstance from 'utils/axios';
import { setError } from 'redux/slices/global';
import { createConfig, updateConfig } from 'redux/slices/config';
import { useState } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'redux/store';
import { useSettingsContext } from 'components/settings';
import { ICatchApiForlike } from '../../@types/error';
import ConfigForm from 'sections/@dashboard/admin/Config/ConfigForm';
ListService.getLayout = (page: React.ReactElement) => <DashboardLayout>{page}</DashboardLayout>;

export default function ListService({ term }: { term?: IConfig }) {
  const { themeStretch } = useSettingsContext();
  const { user } = useSelector((state) => state.global);
  const router = useRouter();
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleSubmit = async (data: ICreateConfig) => {
    let err: [IConfig | null, ICatchApiForlike | null] = [null, null];
    if (term?.id) err = await updateConfig(term.id, data);
    else err = await createConfig(data);

    if (err[1]) {
      setError(err[1].errors);
    } else router.reload();
  };

  return (
    <Container>
      {user?.permission && user?.permission['config'] && (
        <Button size="small" variant="outlined" onClick={handleOpen}>
          {open ? 'Đóng' : 'Chỉnh sửa'}
        </Button>
      )}
      <Collapse in={!open}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Markdown children={term?.value ?? ''} />
          </Grid>
        </Grid>
      </Collapse>
      <Collapse in={open}>
        <Card sx={{ p: 2 }}>
          <Typography>CHỈNH SỬA THÔNG TIN</Typography>
          <ConfigForm config={term} onSubmit={handleSubmit} type="markdown" />
        </Card>
      </Collapse>
    </Container>
  );
}

export async function getServerSideProps({ req, res }: GetServerSidePropsContext) {
  res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate=60');
  try {
    const cookies = req?.headers.cookie ? `${req.headers.cookie};` : '';
    const config = {
      headers: {
        Cookie: cookies,
      },
    };

    const { data } = await axiosInstance.get<IConfig[]>(
      `/api/v1/config/${req.headers.host}/terms`,
      config
    );

    return { props: { term: data[0] } };
  } catch (e) {
    return { props: { term: null } };
  }
}
